import styled from 'styled-components';

const DataSetResponseCreateStyles = styled.div`
  i.fa-spin {
    margin-left: 20px;
  }
`;

export default DataSetResponseCreateStyles;
